
import axios from "axios";

const api = axios.create({
    headers: {
        "Content-Type": "application/json",
    },
    withCredentials: true
});

api.interceptors.response.use(
    (config) => {
        const newToken = config.headers["x-refresh-token"];
        if (newToken) {
            localStorage.setItem("token", newToken);
        }
        return config;
    },
    (error) => {
        if (error.response?.status === 401) {
            if (typeof window !== "undefined") {
                localStorage.removeItem("token");
                // window.location.href = "/login";
            }
        }
        return Promise.reject(error);
    }
);

// export async function apiFetch(url, options = {}) {
//     const token = localStorage.getItem("token");

//     const headers = {
//         ...options.headers,
//         Authorization: token ? `Bearer ${token}` : undefined,
//         "Content-Type": "application/json"
//     };

//     const res = await fetch(url, { ...options, headers });

//     const newToken = res.headers.get("x-refresh-token");
//     if (newToken) localStorage.setItem("token", newToken);

//     if (!res.ok) {
//         const errorData = await res.json();
//         throw new Error(errorData.errorMessage || "Something went wrong");
//     }

//     return res.json();
// }

export default api;
